/**
 * Section: Page - Museum
 * ------------------------------------------------------------------------------
 * @namespace PageMuseum
 */
import {register} from '@shopify/theme-sections';
import SliderPageCarousel from '../components/slider-page-carousel';
import SliderPageModal from '../components/slider-page-modal';

/**
 * Register the `example-section` section type.
 */
register('page-museum', {

  /**
   * Callback function when section is loaded via `sections.load()` or
   * by the Theme Editor `shopify:section:load` event.
   */
  onLoad() {
    SliderPageCarousel().init();
    SliderPageModal().init();
  },
});
